import type { ReactNode } from "react";

import { GauTerm } from "./GauTerm";

/**
 * Renders a plain string, replacing each whole-word "GAU" / "GAUs" with
 * {@link GauTerm} so every mention gets the dotted underline + definition
 * tooltip. Word-boundary anchored so substrings of larger words (e.g.
 * "GAUGE") are left untouched.
 */
export function GauInText({ children }: { children: string }): ReactNode {
  const parts = children.split(/\b(GAUs?)\b/g);
  return (
    <>
      {parts.map((part, index) => {
        if (part === "GAUs") {
          return <GauTerm key={index} plural />;
        }
        if (part === "GAU") {
          return <GauTerm key={index} />;
        }
        if (!part) {
          return null;
        }
        // whitespace-pre-wrap: inside flex containers (e.g. button labels) the
        // split turns each part into its own inline box, and edge whitespace
        // of a box collapses — "Refill 100 GAUs · $125" rendered as
        // "Refill 100GAUs· $125". Preserving whitespace keeps the spaces while
        // still allowing normal line wrapping in prose.
        return (
          <span key={index} className="whitespace-pre-wrap">
            {part}
          </span>
        );
      })}
    </>
  );
}
